<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">Seleziona destinatario della fattura</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px">
    <p><a href="">Cerca in rubrica</a> o <a>inserisci un nuovo destinatario</a></p>
</div>

<div style="flex: 1">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li *ngFor="let tab of configTabs.config" class="nav-item" role="presentation">
            <button class="nav-link" [ngClass]="{'active': configTabs.selected == tab.id}"  (click)="configTabs.selected = tab.id" [id]="tab.id + '-tab'" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="false">
            {{tab.name}}
            </button>
        </li>
    </ul>
</div>


<div class="tab-content">

  <!-- RICERCA IN RUBRICA -->

  <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 1}" id="1" role="tabpanel" aria-labelledby="home-tab">
    <div class="modal-body" style="padding: 10px">
      <div style="display: flex; flex-direction: row;align-items: baseline;flex-wrap: wrap;">
        <div *ngIf="innerWidth! <= 767" class="break" style="margin-bottom: 10px;"></div>
        <div class="input-group" style="margin-left: 10px; flex: 1;">
            <input type="text" [ngClass]="( titleSearch.length > 3 ) ? '' : 'borderRed'" [ngStyle]="{'border-radius': '10px 0px 0px 10px'}" [(ngModel)]="titleSearch" (keyup)="search($event)" class="form-control" placeholder="Cerca per partita IVA o denominazione" aria-label="Cerca per nome" aria-describedby="basic-addon1">
            <span class="input-group-text" id="basic-addon1" (click)="search(null)"><i class="bi bi-search"></i> <!--{{ 'general.search' | translate }}--> </span>
        </div>
      </div>
      <div *ngIf="listAddress.length > 0" style="align-items: baseline;flex-wrap: wrap;" class="text-right mt-2">
        <button [disabled]="previousPage==currentPage" class="btn btn-sm mr-1" (click)="prev()">
            <i class="bi bi-caret-left-fill"></i>
        </button>
        <button [disabled]="currentPage==nextPage" class="btn btn-sm" (click)="next()">
            <i class="bi bi-caret-right-fill"></i>
        </button>
      </div>
    </div>
    <div style="margin: 10px; overflow-x: auto;">
      <table class="table" *ngIf="listAddress.length > 0">
        <thead>
          <tr>
              <th scope="col" style="max-width: 40px; width: 40px;"></th>
              <th scope="col">{{'invoices.edit.entities.other.denomination' | translate}}</th>
              <th scope="col">{{'invoices.edit.entities.other.piva' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of listAddress" (click)="doc.selected = true; selectOne(doc)" style="cursor: pointer;">
              <td>
                  <input type="checkbox" class="form-check-input" style="margin-left: 0;" [(ngModel)]="doc.selected" (ngModelChange)="selectOne(doc)">
              </td>
              <td>
                  <h5 *ngIf="doc.denominazione.length > 0">{{doc.denominazione}}</h5>
                  <h5 *ngIf="doc.denominazione.length == 0">{{doc.nome}} {{doc.cognome}}</h5>
              </td>
              <td>
                  <h5>{{doc.partita_iva}}</h5>
              </td>
          </tr>
        </tbody> 
      </table>
      <ng-container *ngIf="listAddress && listAddress.length == 0 && !first && !loading">
        <ngb-toast [autohide]="false" class="warning">
            <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
            {{'general.noResults' | translate}}
        </ngb-toast>
      </ng-container>
      <app-loading *ngIf="loading"></app-loading>
    </div>
  </div>

  <!-- INSERIMENTO NUOVO ELEMENTO -->

  <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 2}" id="2" role="tabpanel" aria-labelledby="home-tab">
    
    <div class="row" style="margin: 10px; overflow-x: auto;">
      <div class="col-6">
        <label class="roboSubTitle">{{'invoices.edit.entities.general.denomination' | translate}}</label>
        <div class="cerca-pa-container">
          <div class="input-group" style="flex: 1">
            <input type="text" *ngIf="rubricaElement.persona_fisica == 'f'" [ngClass]="[rubricaElement.denominazione != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
              (keyup)="rubricaElement!.denominazione = toUpperCaseAndSubstitute(rubricaElement!.denominazione)" required
              [(ngModel)]="rubricaElement!.denominazione" class="form-control" placeholder="Denominazione">
            <div *ngIf="rubricaElement.persona_fisica == 't'" class="input-group">
                <input type="text" placeholder="Nome" class="form-control" [(ngModel)]="rubricaElement.nome">
                <input type="text" placeholder="Cognome" class="form-control" [(ngModel)]="rubricaElement.cognome">
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="setPersonaFisica()">Persona giuridica</button>
            </div>
            <div class="btn-group" role="group">
                <!--<button *ngIf="rubricaElement.persona_fisica == 'f'" class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="cercaPA()">PA</button>-->
                <button *ngIf="rubricaElement.persona_fisica == 'f'" class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="setPersonaFisica()">Persona fisica</button>
            </div>
          </div>
          <div class="dropdown-menu" [ngClass]="{'show': elencoPA && elencoPA.length > 0}">
            <ul class="list-unstyled mb-0">
              <li *ngFor="let risultato of elencoPA" 
                  class="dropdown-item" 
                  (click)="selezionaRisultato(risultato)">
                  {{ risultato.des_amm }}
              </li>
            </ul>
          </div>
        </div>
        
      </div>
      <div class="col-6">
          <!-- EMAIL PEC -->
          <label  class="roboSubTitle">PEC</label>
          <input class="form-control" type="text"  [(ngModel)]="rubricaElement.pec">
      </div>
  </div>
    <div class="row" style="margin: 10px; overflow-x: auto;">
      <div class="col-2">
        <label class="roboSubTitle">Codice nazione</label>
        <div class="input-group" style="flex: 1">
          <input type="text" maxlength="2" [ngClass]="[rubricaElement.denominazione != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.id_paese = toUpperCaseAndSubstitute(rubricaElement!.id_paese)"
            [(ngModel)]="rubricaElement!.id_paese" class="form-control" placeholder="Codice nazione" (ngModelChange)="notifyChange();" list="countries">
        </div>
      </div>
      <div class="col-4">
        <label class="roboSubTitle">Partita IVA</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.partita_iva != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement.partita_iva = checkVatFormat(rubricaElement.partita_iva, $event)"
            [(ngModel)]="rubricaElement!.partita_iva" class="form-control" placeholder="Partita IVA">
        </div>
      </div>
      <div class="col-4">
        <label class="roboSubTitle">Codice Fiscale</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.codice_fiscale != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            [(ngModel)]="rubricaElement!.codice_fiscale" class="form-control" placeholder="Codice Fiscale">
        </div>
      </div>
      <div class="col-2">
        <label class="roboSubTitle">Codice destinatario</label>
        <div class="input-group" style="flex: 1">
          <input type="text" maxlength="7" [ngClass]="[rubricaElement.codice_destinatario != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.codice_destinatario = toUpperCaseAndSubstitute(rubricaElement!.codice_destinatario)"
            [(ngModel)]="rubricaElement!.codice_destinatario" class="form-control" placeholder="Codice destinatario">
        </div>
      </div>
    </div>
    <div class="row" style="margin: 10px; overflow-x: auto;">
      <div class="col-9">
        <label class="roboSubTitle">Indirizzo</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.indirizzo != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.indirizzo = toUpperCaseAndSubstitute(rubricaElement!.indirizzo)"
            [(ngModel)]="rubricaElement!.indirizzo" class="form-control" placeholder="Indirizzo">
        </div>
      </div>
      <div class="col-3">
        <label class="roboSubTitle">Numero civico</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.civico != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.civico = toUpperCaseAndSubstitute(rubricaElement!.civico)"
            [(ngModel)]="rubricaElement!.civico" class="form-control" placeholder="Numero civico">
        </div>
      </div>
    </div>
    <div class="row" style="margin: 10px; overflow-x: auto;">
      <div class="col-3">
        <label class="roboSubTitle">Nazione</label>
        <div class="input-group" style="flex: 1">
          <input type="text" maxlength="2" [ngClass]="[rubricaElement.nazione != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.nazione = toUpperCaseAndSubstitute(rubricaElement!.nazione)"
            [(ngModel)]="rubricaElement!.nazione" class="form-control" placeholder="Nazione">
        </div>
      </div>
      <div class="col-3">
        <label class="roboSubTitle">Provincia</label>
        <div class="input-group" style="flex: 1">
          <input type="text" maxlength="2" [ngClass]="[rubricaElement.provincia != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.provincia = toUpperCaseAndSubstitute(rubricaElement!.provincia)" aria-describedby="basic-addon1"
            [(ngModel)]="rubricaElement!.provincia" class="form-control" placeholder="Provincia" >
        </div>
      </div>
      <div class="col-4">
        <label class="roboSubTitle">Citt&agrave;</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.comune != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            (keyup)="rubricaElement!.comune = toUpperCaseAndSubstitute(rubricaElement!.comune)" aria-describedby="basic-addon1"
            [(ngModel)]="rubricaElement!.comune" class="form-control" placeholder="Citt&agrave;">
        </div>
      </div>
      <div class="col-2">
        <label class="roboSubTitle">CAP</label>
        <div class="input-group" style="flex: 1">
          <input type="text" [ngClass]="[rubricaElement.cap != '' ? 'borderGreen' : 'borderRed']" [ngStyle]="{'border-radius': '10px 10px 10px 10px'}" 
            [(ngModel)]="rubricaElement!.cap" class="form-control" placeholder="CAP" (ngModelChange)="notifyChange();">
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
</div>